import React from 'react'
import { cloneDeep } from 'lodash'
import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'

import PanelHeader from '../components/PanelHeader.jsx'

import { CONTROLS_COMPONENTS } from './constants.js'

class ControlPane extends React.Component {
    panelScrollRef = React.createRef()

    constructor(props) {
        super(props)
    }

    onClick = evt => {
        evt.preventDefault()
        evt.stopPropagation()
    }

    onControlUpdate = (id, data, payload) => {
        const { onUpdate, isApp } = this.props

        if (isApp) {
            onUpdate(data)
        } else {
            onUpdate({
                [id]: {
                    data,
                    payload,
                },
            })
        }
    }

    getSchemaItemsWithControl = (s, d) => {
        const result = []
        for (const [key, value] of Object.entries(s)) {
            if (value.control && CONTROLS_COMPONENTS[value.control]) {
                result.push({
                    name: key,
                    value: d[key],
                    schema: value,
                })
            }
        }
        return result
    }

    getSchemaItemByName = (s, n) => {
        return s.find(item => item.name === n)
    }

    render() {
        const {
            blockData,
            schema,
            controls = [],
            selectedBlockArrayProperty,
            blockName,
            methods: { openModalByName },
        } = this.props

        let _blockData = cloneDeep(blockData),
            _schema = cloneDeep(schema)

        const payload = {}

        if (selectedBlockArrayProperty) {
            const { arrName, index, schema: arrayPropertySchema } = selectedBlockArrayProperty
            if (arrName && index >= 0 && arrayPropertySchema) {
                // редактирование подсвойства (элемента в массиве) блока, вместо самого блока
                _blockData = blockData[arrName][index]
                _schema = selectedBlockArrayProperty.schema
                payload['selectedBlockArrayProperty'] = selectedBlockArrayProperty
            }
        }

        const schemaItemsWithControl = this.getSchemaItemsWithControl(_schema, _blockData)
        const colorTheme =
            blockData && blockData.colorTheme ? blockData.colorTheme : blockData.pcl ? blockData.pcl : null

        return (
            <div className="editor-panel editor-panel--controls" onClick={this.onClick}>
                <PanelHeader blockName={blockName} scrollRef={this.panelScrollRef} />
                <SimpleBar
                    autoHide={false}
                    style={{ height: 'calc(100% - 56px)', width: '100%' }}
                    scrollableNodeProps={{ ref: this.panelScrollRef }}
                >
                    {controls.length ? (
                        <ul className="list">
                            {controls.map((group, i) => {
                                if (!group.isVisible) {
                                    return null
                                }
                                const values = group.values.filter(value => value.isVisible)
                                if (!values.length) {
                                    return null
                                }
                                return (
                                    <li key={i}>
                                        <p className="group-label">{group.label}</p>
                                        <ul>
                                            {values.map(item => {
                                                const el = this.getSchemaItemByName(schemaItemsWithControl, item.value)
                                                if (!el) {
                                                    return null
                                                }
                                                const Component = CONTROLS_COMPONENTS[el.schema.control]
                                                return (
                                                    <li key={item.value}>
                                                        <Component
                                                            id={blockData.id}
                                                            name={el.name}
                                                            value={el.value}
                                                            tooltipText={item.tooltipText}
                                                            tooltipCallback={item.tooltipCallback}
                                                            descriptionText={item.descriptionText}
                                                            schemaName={item.value}
                                                            schema={el.schema}
                                                            onUpdate={this.onControlUpdate}
                                                            payload={payload}
                                                            openModalByName={openModalByName}
                                                            colorTheme={colorTheme}
                                                        />
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    </li>
                                )
                            })}
                        </ul>
                    ) : (
                        <p className="empty">No additional settings</p>
                    )}
                </SimpleBar>
            </div>
        )
    }
}

export default ControlPane
